import { useCreateTimeAssignment } from "./useCreateTimeAssignment";
import { useUpdateTimeAssignment } from "./useUpdateTimeAssignment";
import { toast } from "react-toastify";
import { handleAxiosError } from "@/api/common/handleAxiosError";
import type { ICreateTimeAssignmentFormData, IListTimeAssignmentsResponse, IUpdateTimeAssignmentFormData } from "@/api/timeAssignments/types";

export const useSaveEstimatedTimes = (getInfo: () => void) => {
  const { mutateAsync: createTimeAssignment } = useCreateTimeAssignment();
  const { mutateAsync: updateTimeAssignment } = useUpdateTimeAssignment();

  const saveEstimatedTimes = async (
    item: IListTimeAssignmentsResponse,
    editedEstimatedTimes: { [taskId: string]: { [date: string]: number } }
  ) => {
    // ...toda la lógica de payloads y guardado aquí (igual que tu función actual)
    const createPayload: Array<ICreateTimeAssignmentFormData> = [];
    const updatePayloads: Array<IUpdateTimeAssignmentFormData> = [];

    // Map para buscar schedules existentes
    const schedulesMap: { [taskAssignmentId: string]: { [date: string]: { id: string } } } = {};
    item.assignments.forEach(assignment => {
      schedulesMap[assignment.task_assignment_id] = {};
      assignment.schedules.forEach(sch => {
        const date = sch.scheduleDate.substring(0, 10);
        schedulesMap[assignment.task_assignment_id][date] = { id: sch.id };
      });
    });

    Object.entries(editedEstimatedTimes).forEach(([taskAssignmentId, days]) => {
      Object.entries(days).forEach(([scheduleDate, estimatedTime]) => {
        if (typeof estimatedTime === "number" && estimatedTime > 0) {
          const scheduleId = schedulesMap[taskAssignmentId]?.[scheduleDate]?.id;
          if (scheduleId) {
            // Actualizar
            updatePayloads.push({
              id: scheduleId,
              estimatedTime: String(estimatedTime),
            });
          } else {
            // Crear
            createPayload.push({
              taskAssignmentId,
              estimatedTime: String(estimatedTime),
              scheduleDate,
            });
          }
        }
      });
    });

    if (createPayload.length === 0 && updatePayloads.length === 0) {
      return;
    }

    try {
      // Crear nuevos
      if (createPayload.length > 0) {
        await toast.promise(
          createTimeAssignment(createPayload, {
            onSuccess: () => {
              getInfo();
            }
          }),
          {
            pending: "Creando estimaciones de tiempo...",
            success: "Estimaciones de tiempo creadas exitosamente",
            error: "Error al crear estimaciones de tiempo"
          }
        );
      }
      // Actualizar existentes (uno a uno)
      if (updatePayloads.length > 0) {
        await toast.promise(
          updateTimeAssignment(updatePayloads, {
            onSuccess: () => {
              getInfo();
            }
          }),
          {
            pending: "Actualizando estimación...",
            success: "Estimación actualizada exitosamente",
            error: "Error al actualizar la estimación"
          }
        );
      }
    } catch (error) {
      handleAxiosError(error, "Error al guardar cambios.");
    }
  };

  return { saveEstimatedTimes };
};